import { render, staticRenderFns } from "./MessageHistoryDay.vue?vue&type=template&id=aa605870&"
import script from "./MessageHistoryDay.vue?vue&type=script&lang=ts&"
export * from "./MessageHistoryDay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports